import { httpsCallable } from "firebase/functions";
import { functions } from "../../services/firebase";
const callables = {};
const call = async (name, payload) => {
  callables[name] ||= httpsCallable(functions, name, { timeout: 120000 });
  let response;
  try {
    response = await callables[name](payload);
  } catch (error) {
    if (error.code?.startsWith("functions/")) error.code = error.code.slice(10);
    throw error;
  }
  const result = response.data || response;
  if (result.ok === false)
    throw new Error(
      result.error?.message || "This source action could not finish.",
    );
  return result;
};
export const mutateCareRecords = (payload) =>
  call("mutateCareRecords", payload);
export const getCareEvidenceReview = (payload) =>
  call("getCareEvidenceReview", payload);
export const reviewCareEvidence = (payload) =>
  call("reviewCareEvidence", payload);
export const getCareRecordHistory = (payload) =>
  call("getCareRecordHistory", payload);
